// Vue & Plugins
import { storeToRefs } from 'pinia'

// Models
import { Ability, Subject } from '../../sites/models/sitePermission'

// Stores
import { useAuthSiteStore } from '../../user/authSiteStore'
import { computed } from 'vue'

export function useHasPermission() {
    const authSiteStore = useAuthSiteStore()
    const { current, currentPermissions } = storeToRefs(authSiteStore)

    const can = (ability: Ability, subject: Subject) => {
        return currentPermissions.value.some((permission) => {
            return permission.ability === ability && permission.subject === subject
        })
    }

    const canCreateBuildings = computed(() => current.value?.permissions.buildings.canCreate ?? false)
    const canCreateGroups = computed(() => current.value?.permissions.groups.canCreate ?? false)
    const canCreateReasons = computed(() => current.value?.permissions.reasons.canCreate ?? false)
    const canCreateSkills = computed(() => current.value?.permissions.skills.canCreate ?? false)
    const canManageShifts = computed(() => current.value?.permissions.shifts.canManage ?? false)

    return { can, canCreateBuildings, canCreateGroups, canCreateReasons, canCreateSkills, canManageShifts }
}
